'use strict';

angular.module('shiftTraderApp')
    .controller('AvailabilityManagementRequestsCtrl', function($scope, AvailabilityRules, TimeService,
                                                       $state, $stateParams, $location,
                                                       SAErrorHandler, me, org,
                                                       Session, allMedUsers, availability_sets_in_review, AvailabilitySets,
                                                       AvailabilityChangeRequests, availability_change_requests,
                                                       UserAvailabilityChangeRequests) {
      $scope.me = me;
      $scope.org = org;
      $scope.availabilitySetsInReview = availability_sets_in_review;

     //  Order of userAvailabilityChangeRequests
     // In review, Awaiting new response, No response, Approved

      $scope.availability_sets_not_in_change_requests = _.where($scope.availability_sets_in_review, function(availSet) {
        return !availSet.$belongsToChangeRequest();
      });

      $scope.availabilityChangeRequests = _.map(availability_change_requests, function(acr) {
        acr.$calcStats();
        return acr;
      });

      $scope.active_acr = _.find($scope.availabilityChangeRequests, function(acr) {
        return !acr.$isExpired();
      });

    $scope.expiredAvailabilityChangeRequests = _.sortBy(_.where($scope.availabilityChangeRequests, function(acr) {
      return acr.$isExpired();
    }), function(acr) {
      return -1 * acr.created_at.unix();
    });

      $scope.allDepartments = _.map($scope.org.departments, function(dept) {
        dept._selected = true;
        return dept;
      });

      $scope.allMedUsers = _.sortBy(_.where(allMedUsers, function(u) {
        return u.$curMemb().active === 1;
      }), 'first_name');

      $scope.nowDate = TimeService.getNowInStoreTime();
      $scope.currentDate = TimeService.getBeginningOfDayFromDate(moment.utc($stateParams.date)).startOf('month');
      $scope.workDayStartHour = Session.getWorkDayStartHour();

      $scope.state = {
        selectedDepartments: _.cloneDeep($scope.org.departments)
      };

    $scope.toggleDepartmentSelection = function(idx) {
      $scope.allDepartments[idx]._selected = !$scope.allDepartments[idx]._selected;
      if (!$scope.allDepartments[idx]._selected) {
        var idy = _.findIndex($scope.state.selectedDepartments, {id: $scope.allDepartments[idx].id});
        $scope.state.selectedDepartments.splice(idy, 1);
      } else {
        $scope.state.selectedDepartments.push($scope.allDepartments[idx]);
      }
      calculateFilteredArrays();
    };

    var calculateFilteredArrays = function() {
      //create the requisite array of availability_set's that are in-review

      // filter by department based on availability_set.user.metadata
      var departmentIdsToShow = _.pluck($scope.state.selectedDepartments, 'id');

      $scope.inReviewAvailabilitySetsToShow = _.where($scope.availabilitySetsInReview, function(availSet) {
        var hasDeptMetadata = availSet.user.metadata && availSet.user.metadata.department_ids_by_org &&
          availSet.user.metadata.department_ids_by_org.data && availSet.user.metadata.department_ids_by_org.data[availSet.organization_id];

        //return !availSet.$belongsToChangeRequest() && availSet.$isInReview() && (!hasDeptMetadata || _.any(departmentIdsToShow, function(idToShow) {
        //    return _.contains(availSet.user.metadata.department_ids_by_org.data[availSet.organization_id], idToShow);
        //  }));
        return !availSet.$belongsToChangeRequest() && availSet.$isInReview();
      });

    };
    
    calculateFilteredArrays();
  });
